import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon.js';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';

function Input(_ref) {
  let {
    className,
    margin,
    type,
    error,
    disabled,
    icon,
    componentRef
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "margin", "type", "error", "disabled", "icon", "componentRef"]);

  let cssClasses = ['st_input'];
  cssClasses = addClassNames(className, cssClasses);
  let containerClasses = ['st_inputwrapper'];
  const inputProps = {};
  if (margin && !icon) cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });

  if (margin && icon) {
    containerClasses = addSpacingClasses({
      margin,
      cssClasses: containerClasses
    });
  }

  if (error) {
    inputProps['aria-invalid'] = !!error;
    cssClasses.push('st_input--invalid');
  }

  if (disabled) {
    inputProps.disabled = disabled;
    cssClasses.push('st_input--disabled');
  }

  if (icon) {
    cssClasses.push('st_input--withicon');

    if (disabled) {
      containerClasses.push('st_inputwrapper--disabled');
    }

    if (error) {
      containerClasses.push('st_inputwrapper--invalid');
    }

    return /*#__PURE__*/React.createElement("div", {
      className: containerClasses.join(' ')
    }, /*#__PURE__*/React.createElement("input", _extends({
      type: type,
      className: cssClasses.join(' ')
    }, inputProps, otherProps)), /*#__PURE__*/React.createElement(Icon, {
      type: icon,
      className: "st_input__icon"
    }));
  }

  return /*#__PURE__*/React.createElement("input", _extends({
    ref: componentRef,
    type: type,
    className: cssClasses.join(' ')
  }, inputProps, otherProps));
}

Input.propTypes = {
  /** extra CSS classes, if any */
  className: classNameProps,

  /** type of input */
  type: PropTypes.string,

  /** margin for box, if any */
  margin: marginProps,

  /** whether input is invalid, e.g. error state */
  error: PropTypes.bool,

  /** whether input is disabled */
  disabled: PropTypes.bool,

  /** optional icon */
  icon: PropTypes.node,

  /** ref for element */
  componentRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })])
};
Input.defaultProps = {
  className: null,
  margin: null,
  type: 'text',
  error: false,
  disabled: false,
  icon: null,
  componentRef: null
};

export default Input;
